import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { useLocation, useNavigate } from "react-router-dom";

const AccountLayout = ({ title, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <app-popup-page className="ng-tns-c4268204220-0 popup-page-wrapper active">
      <div
        _ngcontent-serverapp-c2790459173
        className="popup-page popup-page--active popup-page--align-top"
      >
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__backdrop"
        />
         <OutsideClickHandler onOutsideClick={() => navigate(-1)}>
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__main popup-page-main popup-page-main--show"
        >
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page-main__header"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__title"
            >
              {title}
            </div>
            <div
              onClick={() => navigate("/")}
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__close ng-star-inserted"
            />
          </div>
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page-main__container"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className={`content ${
                location?.pathname !== "/transaction-records" ? "fixed-tab" : ""
              }  player-content`}
            >
              <router-outlet _ngcontent-serverapp-c2790459173 name="popup" />
              <ng-component className="ng-star-inserted">
                <ng-component
                  _nghost-serverapp-c613070388
                  className="ng-tns-c613070388-14 ng-star-inserted"
                >
                  {children}
                </ng-component>
              </ng-component>
            </div>
          </div>
        </div></OutsideClickHandler>
      </div>{" "}
    </app-popup-page>
  );
};

export default AccountLayout;
